import React from 'react';
import { Grid, withStyles, FormControl, TextField } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { tenantInfo, getTenantPermission } from '../../utils/tenantInformation';

class SelectTenant extends React.Component {
  render() {
    const { classes, t, tenant, allTenantsHiding } = this.props;
    let tenants = tenantInfo();
    // sort tenants
    tenants && tenants.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));

    const tenantPermission = getTenantPermission();

    return (
      tenantPermission &&
      tenantPermission.length !== 1 && (
        <div className={classes.wrap}>
          <Grid container item xs={12} sm={12} md={12}>
            <FormControl className={classes.formControl}>
              <TextField
                variant='outlined'
                select
                size='small'
                value={tenant}
                name='tenant'
                id='groupId'
                className={classes.contentSelect}
                onChange={(e) => {
                  this.props.handleChangeTenant(e);
                }}
                SelectProps={{
                  native: true,
                  IconComponent: () => (
                    <div className={classes.iconSelect}>
                      <svg width='15' height='8' viewBox='0 0 15 8'>
                        <use xlinkHref={`/images/toolbar.svg#dropdown`} />
                      </svg>
                    </div>
                  ),
                }}
              >
                <option value='' disabled>
                  {t('select_tenant')}
                </option>
                {!allTenantsHiding && tenants.length > 1 && <option value={0}>{t('all')}</option>}
                {(tenants || []).map((val) => (
                  <option value={JSON.stringify([val.id])} key={`group-${val.id}`}>{`${val.name || ' - '}`}</option>
                ))}
              </TextField>
            </FormControl>
          </Grid>
        </div>
      )
    );
  }
}

const styles = (theme) => ({
  wrap: {
    width: '250px',
    [theme.breakpoints.down('md')]: {
      width: '200px',
    },
  },
  formControl: {
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    margin: theme.spacing.unit / 2,
    width: '100%',
  },
  contentSelect: {
    display: 'flex',
    '& fieldset': {
      top: '2px',
    },
    '& svg': {
      top: 'calc(58% - 8px)',
    },
    '& select': {
      paddingTop: '17px',
      paddingBottom: '9px',
    },
  },
  iconSelect: {
    position: 'absolute',
    backgroundColor: 'transparent !important',
    display: 'flex',
    marginBottom: '10px',
    top: 'calc(58% - 3px)',
    right: 'calc(10% - 14px)',
  },
  fontTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    marginTop: theme.spacing.unit,
  },
});

export const translation = withTranslation()(SelectTenant);
export default withStyles(styles, { withTheme: true })(translation);
